export const policyData = [
    {
        _id: 1,
        policyName: 'HR Policy',
        subPolicyList: [
            {
                _id: 1,
                title: 'ATTENDANCE AND LEAVE POLICY',
                description: 'ATTENDANCE AND LEAVE POLICY',
                updatedAt: "2025-11-20T11:40:27.979Z",
                createdAt: "2025-11-20T11:40:27.979Z",
                content:  
                "<p><strong>OBJECTIVES</strong></p><p>•Every individual in the organization is working towards a goal.</p><p>•Absence of any employee has an impact on the overall organization goals.</p><p>•While taking leaves and time-offs are important, it is equally important to plan for the impact</p><p>due to absence.</p><p>•Leaves must be taken in planned way as much as possible.</p>"
                
            },
            {
                _id: 2,
                title: 'POSH',
                description: 'PREVENTION OF SEXUAL HARRASMENT',
                updatedAt: "2025-11-20T11:40:27.979Z",
                createdAt: "2025-11-20T11:40:27.979Z",
                content:  
                "<p><strong>OBJECTIVES</strong></p><p>•Every individual in the organization is working towards a goal.</p><p>•Absence of any employee has an impact on the overall organization goals.</p><p>•While taking leaves and time-offs are important, it is equally important to plan for the impact</p><p>due to absence.</p><p>•Leaves must be taken in planned way as much as possible.</p>"
                
            },
            {
                _id: 3,
                title: 'Company Policy',
                description: 'Company Policy - 28 dec 2023',
                updatedAt: "2025-11-20T11:40:27.979Z",
                createdAt: "2025-11-20T11:40:27.979Z",
                content: 
                "<p><strong>OBJECTIVES</strong></p><p>•Every individual in the organization is working towards a goal.</p><p>•Absence of any employee has an impact on the overall organization goals.</p><p>•While taking leaves and time-offs are important, it is equally important to plan for the impact</p><p>due to absence.</p><p>•Leaves must be taken in planned way as much as possible.</p>"
                
            },
        ]
    },
    {
        _id: 2,
        policyName: 'IT Policy',
        subPolicyList: [
            {
                _id: 1,
                title: 'REASOURCE POLICY',
                description: 'ATTENDANCE AND LEAVE POLICY',
                updatedAt: "2025-11-20T11:40:27.979Z",
                createdAt: "2025-11-20T11:40:27.979Z",
                content:  
                "<p><strong>OBJECTIVES</strong></p><p>•Every individual in the organization is working towards a goal.</p><p>•Absence of any employee has an impact on the overall organization goals.</p><p>•While taking leaves and time-offs are important, it is equally important to plan for the impact</p><p>due to absence.</p><p>•Leaves must be taken in planned way as much as possible.</p>"
                
            },
        ]
    },

]